// Components==============
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './index.module.scss';
// =========================

export default function Checkbox({ isSelected, background = '#FFFFFF' }) {
    return (
        <div styleName="wrapper" style={{ background }}>
            <FontAwesomeIcon
                icon={faCheck}
                style={{
                    color: isSelected ? '#3f3f93' : background,
                }}
            />
        </div>
    );
}
